















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "diagnosisTime",
})
export default class diagnosisTime extends Vue {
  private answer = "";
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    // console.log("item---", value);
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
}
